<template>
    <div>
        <div
            v-for="(payment, index) in payments"
            :key="index"
            class="pay-in__created-payment mb-2"
        >
            <div class="d-flex justify-content-between align-items-start">
                <div class="d-flex align-items-center">
                    <reference-avatar :reference="payment.reference" :index="index" class="mr-2" />
                    <div>
                        <div class="fs-small font-weight-600 darker">{{ payment.reference }}</div>
                        <div class="fs-small darkest">{{ truncateLabel(payment.itemsLabel) }}</div>
                        <div
                            v-for="(method, methodIndex) in payment.paymentMethods"
                            :key="methodIndex"
                            class="fs-small darkest"
                        >{{ method.typeName }} {{ method.amountReceived }} €</div>
                    </div>
                </div>
                <div class="d-flex align-items-start mt-1 pay-in__created-payment-actions">
                    <i class="ico ico-edit dark fs-small pointer" @click="$emit('edit', index)"></i>
                    <i class="ico ico-delete dark fs-small pointer" @click="$emit('remove', index)"></i>
                </div>
            </div>
        </div>

        <div v-if="showAddPayment" class="mb-3">
            <span
                class="pay-in__add-method"
                :class="{ 'pay-in__add-method--disabled': disableAdd }"
                @click="onAddPayment"
            >
                <i class="ico-add fs-smallest add-circle color-1 mr-1"></i> Add payment
            </span>
        </div>
    </div>
</template>

<script>
import ReferenceAvatar from '@/tools/modal/ReservationPayIn/ReferenceAvatar'

const MAX_LABEL_LENGTH = 35

export default {
    components: {
        ReferenceAvatar,
    },
    props: {
        payments: {
            type: Array,
            required: true,
        },
        showAddPayment: {
            type: Boolean,
            default: false,
        },
        disableAdd: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        truncateLabel(label) {
            return label.length > MAX_LABEL_LENGTH ? label.substring(0, MAX_LABEL_LENGTH) + '...' : label
        },
        onAddPayment() {
            if (this.disableAdd) return
            this.$emit('add')
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .pay-in__created-payment {
        background: rgba($color-4, 0.25);
        border-radius: 0.25rem;
        padding: 0.5rem 0.75rem;
    }

    .pay-in__created-payment-actions {
        gap: 0.5rem;
    }

    .pay-in__add-method {
        color: $darkest;
        font-weight: 500;
        cursor: pointer;
        font-size: $font-size-small;

        .add-circle {
            transform: scale(0.75);
        }

        &--disabled {
            opacity: 0.4;
            cursor: not-allowed;
        }
    }
</style>



// WEBPACK FOOTER //
// CreatedPartialPaymentList.vue?73c147e2